export class RequestTotalsByTypeAndStatus {
    RequestType: string;
    Status: string;
    RequestCount: number;
}

export default RequestTotalsByTypeAndStatus;